const MODULOS_COM_REFERENCIA_TEMPORAL = new Set(["FOLHA", "FINANCEIRA"]);
const CONTEXTOS_COM_REFERENCIA_TEMPORAL = new Set([
    "ATOS_DE_PESSOAL",
    "GESTAO_FISCAL",
    "REGISTROS_CONTABEIS"
]);

export function getReferenciaTemporalOcorrencia(
    ocorrencia = {},
    ocorrenciaRaiz
) {
    const raiz = ocorrenciaRaiz || ocorrencia;
    const modulo = ocorrencia.moduloOrigem || raiz.moduloOrigem;
    const contexto = ocorrencia.contexto || raiz.contexto;

    if (
        !MODULOS_COM_REFERENCIA_TEMPORAL.has(modulo) &&
        !CONTEXTOS_COM_REFERENCIA_TEMPORAL.has(contexto)
    ) {
        return {itens: []};
    }

    const payload = normalizarJson(
        raiz.dadosEnviados || ocorrencia.dadosEnviados || {}
    );
    const dataFatoGerador =
        ocorrencia.dataFatoGerador || raiz.dataFatoGerador || null;
    const periodoFiscal =
        encontrarPeriodoFiscal({
            ano: raiz.anoFiscal || ocorrencia.anoFiscal,
            bimestre: raiz.bimestreFiscal || ocorrencia.bimestreFiscal
        }) || encontrarPeriodoFiscal(payload);
    const competenciaResumida = raiz.competencia || ocorrencia.competencia;
    const competencia =
        (competenciaValida(competenciaResumida)
            ? `${competenciaResumida}`
            : null) ||
        encontrarCompetencia(payload) ||
        (!periodoFiscal ? competenciaDaData(dataFatoGerador) : null);
    const itens = [];

    if (periodoFiscal) {
        itens.push({
            chave: "periodo-fiscal",
            icone: "date_range",
            rotulo: "Período fiscal",
            valor: `${periodoFiscal.bimestre}º bimestre/${periodoFiscal.ano}`
        });
    } else if (competencia) {
        itens.push({
            chave: "competencia",
            icone: "calendar_month",
            rotulo: "Competência",
            valor: formatarCompetencia(competencia)
        });
    }

    if (dataFatoGerador) {
        itens.push({
            chave: "data-fato-gerador",
            icone: "event_available",
            rotulo: "Fato gerador",
            valor: formatarDataFatoGerador(dataFatoGerador)
        });
    }

    return {
        competencia,
        periodoFiscal,
        dataFatoGerador,
        itens
    };
}

export function encontrarCompetencia(payload) {
    return encontrarNoPayload(payload, (valor) => {
        const anoMes = valor?.anoMes;
        return competenciaValida(anoMes) ? `${anoMes}` : null;
    });
}

export function encontrarPeriodoFiscal(payload) {
    return encontrarNoPayload(payload, (valor) => {
        const ano = `${valor?.ano || ""}`;
        const bimestre = Number(valor?.bimestre);

        if (/^\d{4}$/.test(ano) && bimestre >= 1 && bimestre <= 6) {
            return {ano, bimestre};
        }
        return null;
    });
}

export function formatarCompetencia(anoMes) {
    return competenciaValida(anoMes)
        ? `${anoMes}`.replace(/^(\d{4})(\d{2})$/, "$2/$1")
        : "";
}

export function formatarDataFatoGerador(data) {
    const correspondencia = `${data || ""}`.match(/^(\d{4})-(\d{2})-(\d{2})/);

    if (!correspondencia) return `${data || ""}`;

    return `${correspondencia[3]}/${correspondencia[2]}/${correspondencia[1]}`;
}

function encontrarNoPayload(origem, extrair) {
    const visitados = new Set();

    function procurar(valor) {
        const normalizado = normalizarJson(valor);

        if (!normalizado || typeof normalizado !== "object") return null;
        if (visitados.has(normalizado)) return null;
        visitados.add(normalizado);

        const encontrado = extrair(normalizado);
        if (encontrado) return encontrado;

        for (const filho of Object.values(normalizado)) {
            if (Array.isArray(filho)) {
                for (const item of filho) {
                    const resultado = procurar(item);
                    if (resultado) return resultado;
                }
            } else {
                const resultado = procurar(filho);
                if (resultado) return resultado;
            }
        }

        return null;
    }

    return procurar(origem);
}

function normalizarJson(valor) {
    if (typeof valor !== "string") return valor;

    const texto = valor.trim();
    if (!texto || !["{", "["].includes(texto[0])) return valor;

    try {
        return JSON.parse(texto);
    } catch (error) {
        return valor;
    }
}

function competenciaDaData(data) {
    const correspondencia = `${data || ""}`.match(/^(\d{4})-(\d{2})-/);
    return correspondencia
        ? `${correspondencia[1]}${correspondencia[2]}`
        : null;
}

function competenciaValida(anoMes) {
    if (!/^\d{6}$/.test(`${anoMes || ""}`)) return false;
    const mes = Number(`${anoMes}`.slice(4, 6));
    return mes >= 1 && mes <= 12;
}
